import Helper from './Helper';

class Header {
  constructor() {
    this.lastClickedTopMenu = null;
    this.searchToggles = document.querySelectorAll('.js-search-toggle');
    this.burgerToggles = document.querySelectorAll('.js-burger-toggle');

    this.content = document.querySelector('body .content');

    this.menuItemDesktop = document.querySelectorAll('.menu--main .menu__item--level-0.menu__item--has-children');
    this.submenuWrapper = document.querySelector('.header__navigation');

    if (this.submenuWrapper) {
      this.postMenuWrapper = this.submenuWrapper.querySelector('.post-wrapper');
      this.bindEvents();
    }
  }

  bindEvents() {
    this.searchToggles.forEach(searchToggle => {
      searchToggle.addEventListener('click', (e) => {
        console.log(searchToggle);
        this.toggleSearch();
      });
    });

    this.burgerToggles.forEach(burgerToggle => {
      burgerToggle.addEventListener('click', (e) => {
        this.toggleMenu();
      });
    });

    this.menuItemDesktop.forEach(menuItem => {
      menuItem.addEventListener('click', (e) => {
        if (this.menuOpen() && (this.lastClickedTopMenu == menuItem || this.lastClickedTopMenu == null)) {
          this.closeMenu();
          this.lastClickedTopMenu = null;
          this.clearPostMenu();
        } else {
          e.preventDefault();
          this.clearPostMenu();
          this.openMenu();
          this.lastClickedTopMenu = menuItem;
          this.openSubmenu(menuItem, 1);

          if (menuItem.classList.contains('menu__item--ancestor-active')) {
            this.openActiveChildren(menuItem, 1);
          }
        }
      });
    });


    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeMenu();
      }
    };

  }

  /**
   * Toggles menu and either opens or closes it. Used for Burger
   */
  toggleMenu() {
    if (this.menuOpen()) {
      this.closeMenu();
    } else {
      this.openMenu();

      // open active children
        this.openActiveChildren(null, 0);
    }
  }

  openActiveChildren(menuItem, index) {
    const subMenu = this.submenuWrapper.querySelector('.header__navigation-inner[data-index="' + index + '"]');
    const activeMenuItem = subMenu.querySelector('.menu__item.menu__item--ancestor-active');

    if (activeMenuItem) {
      this.openSubmenu(activeMenuItem, index + 1);
      this.openActiveChildren(activeMenuItem, index + 1)
    }
  }

  /**
   *
   * @param {Node} item Menu Item
   * @param {Number} index submenu Index
   */
  openSubmenu(item, index) {
    const furtherToggles = item.querySelectorAll('.menu__item.menu__item--has-children');
    let sub = this.submenuWrapper.querySelector('.header__navigation-inner[data-index="' + index + '"]');

    let menuPost = item.querySelector('.js-menu-post');

    if (this.searchOpen()) {
      this.closeSearch();
    }

    this.clearSubmenus(index);

    if (index > 0 && !Helper.isDesktop()) {
      let backButton = document.createElement('a');
      backButton.innerHTML = item.querySelector('.menu__link-text').innerHTML;
      backButton.classList.add('menu__item--level-' + index, 'menu__item--back-button');

      sub.appendChild(backButton);

      backButton.addEventListener('click', (e) => {
        this.clearSubmenus(index);
      });
    }

    item.querySelectorAll('.menu__item--level-' + index).forEach(i => {
      let newItem = sub.appendChild(i.cloneNode(true));

      if (newItem.classList.contains('menu__item--has-children')) {
        newItem.addEventListener('click', (e) => {
          e.preventDefault();
          this.openSubmenu(newItem, index + 1);
        })
      }
    });

    if (menuPost) {
      if (Helper.isDesktop()) {
        this.postMenuWrapper.appendChild(menuPost.cloneNode(true));
      } else {
        if (index > 0) {
          sub.appendChild(menuPost.cloneNode(true));
        }
      }
    }
  }

  clearPostMenu() {
    this.postMenuWrapper.innerHTML = '';
  }

  /**
   * @param {Number} index All Submenus after this index will be cleared
   */
  clearSubmenus(index) {
    const subs = this.submenuWrapper.querySelectorAll('.header__navigation-inner');

    subs.forEach(sub => {
      if (sub.dataset.index >= index) {
        sub.innerHTML = '';
      }
    });
  }

  /**
   * Closes menu, search and clears all submenus
   */
  closeMenu() {
    this.closeSearch();
    document.body.classList.remove('menu-open');
    this.clearSubmenus(0);

    this.content.removeEventListener('click', this.contentClickHandler);
  }

  /**
   * Opens menu, does not open any children
   */
  openMenu() {
    document.body.classList.add('menu-open');

    //clone desktop menu into 1. submenu thing
    if (!Helper.isDesktop()) {
      const firstSub = this.submenuWrapper.querySelector('.header__navigation-inner[data-index="0"]');
      const menuItems = document.querySelectorAll('#main-menu > .menu__item');
      const menu = document.querySelector('#main-menu');

      this.openSubmenu(menu, 0);

      // menuItems.forEach(item => {
      //   firstSub.appendChild(item.cloneNode(true));
      //   console.log(item)

      //   if (item.classList.contains('menu__item--has-children')) {
      //     item.addEventListener('click', (e) => {
      //       e.preventDefault();
      //       this.openSubmenu(toggle, 1);
      //     });
      //   }
      // })
    }

    this.content.addEventListener('click', this.contentClickHandler);
  }

  contentClickHandler = (e) => {
    this.closeMenu();
    this.closeSearch();
  }

  /**
   *
   * @returns {Boolean} bMenuOpen
   */
  menuOpen() {
    if (this.searchOpen()) {
      this.closeSearch();
    }
    return document.body.classList.contains('menu-open');
  }

  toggleSearch() {
    if (this.searchOpen()) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  /**
   * opens search, closes menu on desktop
   */
  openSearch() {
    // close menu on desktop
    if (Helper.isDesktop() && this.menuOpen()) {
      this.closeMenu();
    }
    document.body.classList.add('search-open');
    this.content.addEventListener('click', this.contentClickHandler);
  }

  /**
   * closes search
   */
  closeSearch() {
    document.body.classList.remove('search-open');
  }

  /**
   *
   * @returns {boolean} bSearchOpen
   */
  searchOpen() {
    return document.body.classList.contains('search-open');
  }

} export default Header;
